import { Link, useLocation } from "react-router-dom";
import NotificationBell from "./NotificationBell";

const themeIcons = { dark: "🌙", light: "☀️", auto: "🌗" };
const themeLabels = { dark: "Tối", light: "Sáng", auto: "Tự động" };

const navBtnStyle = (isActive) => ({
  background: isActive ? "#3B82F612" : "transparent",
  border: "none",
  borderRadius: "10px",
  padding: "8px",
  cursor: "pointer",
  fontSize: "16px",
  lineHeight: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "36px",
  height: "36px",
  textDecoration: "none",
  color: isActive ? "#3B82F6" : "var(--text-muted)",
  transition: "all 0.2s",
});

function Tooltip({ label, children, style = {} }) {
  return (
    <div className="nav-tooltip-wrap" style={{ position: "relative", ...style }}>
      {children}
      <div className="nav-tooltip">{label}</div>
    </div>
  );
}

export default function Header({ catColor, streak, session, theme, onLogoClick, notifications, setNotifications }) {
  const location = useLocation();
  const path = location.pathname;
  const user = session?.user?.user_metadata;

  return (
    <>
      {/* Top Header */}
      <div className="top-header">
        {/* Logo */}
        <Link to="/app" onClick={onLogoClick} style={{ textDecoration: "none" }}>
          <div className="header-subtitle" style={{ fontSize: "10px", letterSpacing: "3px", color: "var(--text-muted)", textTransform: "uppercase", marginBottom: "2px" }}>Hành Trình Của Bạn</div>
          <div className="gradient-title" style={{ "--cat-color": catColor, fontSize: "18px" }}>1% Tốt Hơn Mỗi Ngày</div>
        </Link>

        {/* Right side — desktop nav */}
        <div className="desktop-nav">
          {/* Streak badge */}
          <Tooltip label={`Streak hiện tại / Kỷ lục`} style={{ marginRight: "4px" }}>
            <div className="streak-badge">
              <span>🔥 {streak.current_streak}</span>
              <span style={{ color: "var(--text-muted)", fontWeight: "400", fontSize: "10px" }}>/ {streak.longest_streak}</span>
            </div>
          </Tooltip>

          {/* Theme toggle */}
          {theme && (
            <Tooltip label={`Chế độ: ${themeLabels[theme.mode]}`}>
              <button onClick={theme.cycleTheme} style={navBtnStyle(false)}>
                {themeIcons[theme.mode]}
              </button>
            </Tooltip>
          )}

          {/* Notifications */}
          <Tooltip label="Thông báo">
            <NotificationBell notifications={notifications} setNotifications={setNotifications} />
          </Tooltip>

          {/* Community */}
          <Tooltip label="Cộng đồng">
            <Link to="/app/community" style={navBtnStyle(path === "/app/community")}>
              👥
            </Link>
          </Tooltip>

          {/* History */}
          <Tooltip label="Lịch sử">
            <Link to="/app/history" style={navBtnStyle(path === "/app/history")}>
              📅
            </Link>
          </Tooltip>

          {/* Profile avatar */}
          <Tooltip label="Hồ sơ">
            <Link to="/app/profile" style={{ display: "flex", alignItems: "center", textDecoration: "none", marginLeft: "4px" }}>
              {user?.avatar_url ? (
                <img src={user.avatar_url} alt="" style={{
                  width: 32, height: 32, borderRadius: "50%",
                  border: path === "/app/profile" ? "2px solid #3B82F6" : "2px solid var(--border-secondary)",
                  cursor: "pointer", transition: "border-color 0.2s",
                }} />
              ) : (
                <div style={{
                  width: 32, height: 32, borderRadius: "50%", background: "#7C3AED",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "14px", color: "#fff", cursor: "pointer",
                  border: path === "/app/profile" ? "2px solid #3B82F6" : "2px solid var(--border-secondary)",
                }}>
                  {(user?.full_name || user?.email || "?")[0].toUpperCase()}
                </div>
              )}
            </Link>
          </Tooltip>
        </div>

        {/* Mobile header right — only streak + theme + notifications */}
        <div className="mobile-header-right">
          <div className="streak-badge">
            <span>🔥 {streak.current_streak}</span>
          </div>
          {theme && (
            <button onClick={theme.cycleTheme} style={navBtnStyle(false)} aria-label="Đổi theme">
              {themeIcons[theme.mode]}
            </button>
          )}
          <NotificationBell notifications={notifications} setNotifications={setNotifications} />
        </div>
      </div>

      {/* Mobile Bottom Tab Bar */}
      <nav className="bottom-tab-bar">
        <Link to="/app" onClick={onLogoClick} className={`tab-item ${path === "/app" ? "active" : ""}`}>
          <span className="tab-icon">🏠</span>
          <span className="tab-label">Trang chủ</span>
        </Link>
        <Link to="/app/history" className={`tab-item ${path === "/app/history" ? "active" : ""}`}>
          <span className="tab-icon">📅</span>
          <span className="tab-label">Lịch sử</span>
        </Link>
        <Link to="/app/community" className={`tab-item ${path === "/app/community" ? "active" : ""}`}>
          <span className="tab-icon">👥</span>
          <span className="tab-label">Cộng đồng</span>
        </Link>
        <Link to="/app/feedback" className={`tab-item ${path === "/app/feedback" ? "active" : ""}`}>
          <span className="tab-icon">💬</span>
          <span className="tab-label">Góp ý</span>
        </Link>
        <Link to="/app/profile" className={`tab-item ${path === "/app/profile" ? "active" : ""}`}>
          <span className="tab-icon">👤</span>
          <span className="tab-label">Hồ sơ</span>
        </Link>
      </nav>
    </>
  );
}
